// Safari asking "Allow microphone?" again and again. The page keeps one stream for a while
// (MicCapture keepStreamMs), so most restarts don't ask; when the asking still repeats (the site
// is set to "Ask", or a home-screen web app, which iOS asks for on every launch), say once how
// to set it to "Allow". The capture reports a likely prompt (`permission_prompt`: the permission
// said "prompt" when getUserMedia was asked); the page counts them across reloads.

/** Prompts seen before the hint is shown. */
export const PROMPTS_BEFORE_HINT = 2;

/** In a Safari tab: the site's own setting. */
export const PROMPT_HINT_TAB = "Tired of the mic prompt? In Safari, open the page menu (aA) › Website Settings › Microphone › Allow.";
/** In a home-screen web app there is no page menu: Safari's setting for all websites. */
export const PROMPT_HINT_APP = "Tired of the mic prompt? On your iPhone: Settings › Apps › Safari › Microphone › Allow.";

/**
 * The hint to show now, if any: once `prompts` reaches PROMPTS_BEFORE_HINT and it was never
 * shown before (`shown`).
 */
export function promptHint(prompts: number, shown: boolean, standalone: boolean): string | null {
  if (shown || prompts < PROMPTS_BEFORE_HINT) return null;
  return standalone ? PROMPT_HINT_APP : PROMPT_HINT_TAB;
}
